import { useEffect, useState } from "react";

type Theme = "light" | "dark" | "system";

export function useTheme() {
    const [theme, setTheme] = useState<Theme>(() => {
        // Recuperar tema do localStorage ou usar "system" como padrão
        const stored = localStorage.getItem("theme") as Theme | null;
        return stored || "system";
    });

    useEffect(() => {
        const root = window.document.documentElement;

        // Remover classes anteriores
        root.classList.remove("light", "dark");

        if (theme === "system") {
            // Detectar preferência do sistema
            const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
                ? "dark"
                : "light";
            root.classList.add(systemTheme);
        } else {
            // Aplicar tema escolhido manualmente
            root.classList.add(theme);
        }
    }, [theme]);

    useEffect(() => {
        // Listener para mudanças no tema do sistema (quando "system" estiver ativo)
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

        const handleChange = () => {
            if (theme === "system") {
                const root = window.document.documentElement;
                root.classList.remove("light", "dark");
                root.classList.add(mediaQuery.matches ? "dark" : "light");
            }
        };

        mediaQuery.addEventListener("change", handleChange);
        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [theme]);

    const setThemeAndPersist = (newTheme: Theme) => {
        localStorage.setItem("theme", newTheme);
        setTheme(newTheme);
    };

    return { theme, setTheme: setThemeAndPersist };
}


